<template>
    <AppJumbotron without-tyres :class="`!pb-0`">
        <div class="flex items-center">
            <div class="flex-grow max-w-4xl">
                <!--                <div class="my-4 px-6 py-2 rounded bg-white w-1/2 sm:w-1/4">-->
                <!--                    <img :data-src="brand.image" :alt="brand.name" class="object-fit lazy"/>-->
                <!--                </div>-->
                <BrandImage class="w-1/2 sm:w-1/4" :brand="brand"></BrandImage>
                <div class="w-full">
                    <h1 class="text-white text-3xl md:text-5xl !leading-tight font-bold mb-8 !z-20 relative">
                        <span class="font-normal">Find reviews for</span> <span class="font-bold">{{ brand.name }} <br/> tyres </span>
                        <span class="font-normal">at {{ config.name }}</span>
                    </h1>
                    <p class="text-white mb-4 font-normal"><span class="font-bold">{{ numReviews }} reviews</span> <br/>
                        for {{ brand.name }} tyres</p>
                    <AppButton theme="secondary" class="my-4" @click="scrollToRef('reviews')">Read Reviews</AppButton>
                </div>
            </div>
        </div>
    </AppJumbotron>
    <div class="bg-muted py-4 md:py-6">
        <AppContainer class="flex items-center">
            <div class="w-full xl:w-2/5">
                <h1 class="block text-black text-lg font-bold mb-3">
                    {{ brand.seo_tags && brand.seo_tags.h1_tag !== null ? brand.seo_tags.h1_tag : brand.name }}</h1>
                <div class="flex-none font-light" v-html="brand.description"></div>
            </div>
            <div class="hidden md:block w-3/5 xl:w-1/2 relative">
                <img :data-src="brand.hero_image ?? '/images/misc/default_tyres_hero.png'"
                     :alt="brand.name"
                     class="object-fit absolute -top-64 xl:-top-96 lazy !z-10"/>
            </div>
        </AppContainer>
    </div>
    <app-container>
        <div class="grid grid-cols-none lg:grid-cols-2 gap-4 mt-4">
            <div>
                <span class="text-3xl mb-4 block font-light"><span class="font-bold">Highest rated</span> {{
                        brand.name
                    }} tyres</span>
                <p class="font-normal">The most popular {{ brand.name }} tyres as voted by our users</p>
                <div class="mt-5">
                    <Tabs class="mb-4"
                          :items="tabItems"
                          :activeItem="season"
                          @tab-change="tabChange"
                    />

                    <div class="grid grid-cols-2 md:grid-cols-3 gap-8">
                        <TyreCardLoader :items="12" :loading="loadPopularProducts"/>
                        <template v-if="!loadPopularProducts">
                            <TyreCard v-for="product in popularProducts" :product="product"/>

                            <p v-if="!popularProducts || popularProducts.length === 0" class="col-span-full">
                                No {{ season }} tyres found.
                            </p>
                        </template>
                    </div>
                    <div class="w-full mt-8 mb-8" v-if="!loadPopularProducts">
                        <AppButton class="mx-auto !w-auto" @click="scrollPageTo('all')">View all {{ brand.name }}
                            tyres
                        </AppButton>
                    </div>
                </div>
            </div>
            <div>
                <span class="text-3xl mb-4 block font-light"><span class="font-bold">Top reviews</span> for {{
                        brand.name
                    }} tyres</span>
                <p class="font-normal">The most helpful reviews as voted by our users</p>
                <div class="mt-5">
                    <ReviewCardLoader :items="3" :loading="loadTopReviews"/>
                    <ReviewCard v-if="!loadTopReviews" v-for="review in topReviews" :review="review"/>
                </div>
                <div v-if="!topReviews.length" class="mt-5 bg-primary w-full text-center p-4">
                    <span class="text-white">No reviews found</span>
                </div>
            </div>
        </div>
    </app-container>
    <app-container class="mt-4" ref="reviews">
        <span class="text-3xl mb-4 block font-light"><span class="font-bold">Latest reviews</span> for {{ brand.name }} tyres</span>
        <p class="font-normal">The most recent reviews left by our users</p>
        <div class="mt-5">
            <MasonryWall v-if="!loadLatestReviews"
                         :items="latestReviews"
                         :ssr="{columns: 2}"
                         :options="{padding: 12}"
                         :gap="16">
                <template #default="{item, index}">
                    <ReviewCard :key="index" :review="item"/>
                </template>
            </MasonryWall>
            <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
                <ReviewCardLoader :items="6" :loading="loadLatestReviews"></ReviewCardLoader>
            </div>
            <div class="w-full mt-5" v-if="nextReviewPage">
                <AppButton class="mx-auto !w-auto" @click="loadMore">Load more reviews</AppButton>
            </div>
            <div id="reviewsBase"></div>
            <div v-if="!latestReviews.length && loadLatestReviews" class="mt-5 bg-primary w-full text-center p-4">
                <span class="text-white">No reviews found</span>
            </div>
        </div>
    </app-container>
    <app-container id="all" class="mt-4">
        <span class="text-3xl mb-4 block font-light"><span class="font-bold">All</span> {{ brand.name }} tyres</span>
        <div class="flex flex-wrap items-center">
            <div class="w-full lg:w-1/3">
                <p class="font-normal">Find the perfect {{ brand.name }} tyre for you</p>
            </div>
            <div class="w-full md:w-2/3">
                <div class="float-none md:float-right">
                    <span class="font-bold mr-6 mb-0">Filter by season</span>
                    <Tabs :items="tabItems"
                          :activeItem="season"
                          @tab-change="tabChange"
                    />
                </div>
            </div>
        </div>
        <div class="mt-5">
            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
                <TyreCard v-if="!loadAllProducts" v-for="product in allProducts" :product="product"/>
                <TyreCardLoader
                    :items="12"
                    :loading="loadAllProducts"
                />
            </div>
            <div v-if="allProducts.length === 0" class="mt-5 bg-primary w-full text-center p-4">
                <span class="text-white">No tyres found</span>
            </div>
            <div class="w-full mt-6" v-if="nextProductPage">
                <AppButton class="mx-auto !w-auto" @click="loadMoreProducts()">Load more {{ brand.name }} tyres
                </AppButton>
            </div>
        </div>
    </app-container>
</template>

<script>
import BrandImage from "@/Components/Brands/BrandImage.vue";
import {Head, useForm} from "@inertiajs/inertia-vue3";
import MasonryWall from "@yeger/vue-masonry-wall";
import AppJumbotron from "@/Components/AppJumbotron";
import AppButton from "@/Components/AppButton";
import MainLayout from "@/Layouts/MainLayout";
import AppContainer from "@/Layouts/AppContainer";
import ReviewCard from "@/Components/Reviews/ReviewCard";
import ReviewCardLoader from "@/Components/Loaders/ReviewCardLoader";
import TyreCardLoader from "@/Components/Loaders/TyreCardLoader";
import TyreCard from "@/Components/Products/Tyres/TyreCard";
import Tabs from "@/Components/Tabs";
import LazyLoad from "vanilla-lazyload";
import Scroll from "@/Mixins/Utilities/Scroll";
import AppHead from "@/Components/AppSeoTags";

export default {
    name: "BrandPage",
    layout: MainLayout,
    components: {
        BrandImage,
        AppHead,
        TyreCard,
        TyreCardLoader,
        ReviewCardLoader,
        ReviewCard,
        AppButton,
        AppJumbotron,
        AppContainer,
        MasonryWall,
        Tabs,
        Head
    },
    mixins: [Scroll],
    props:
        {
            brand: Object,
            seoTags: Object,
            numReviews: Number,
            config: Object
        },
    data() {
        return {
            loadTopReviews: false,
            loadPopularProducts: false,
            loadLatestReviews: false,
            loadAllProducts: false,
            season: null,
            start: null,
            topReviews: [],
            latestReviews: [],
            popularProducts: [],
            allProducts: [],
            nextReviewPage: null,
            nextProductPage: null,
            tabItems: [
                {value: null, text: "All"},
                {value: "Summer", text: "Summer"},
                {value: "All Season", text: "All Season"},
                {value: "Winter", text: "Winter"}
            ],
            currentPage: 1,
            currentProductPage: 1
        };
    },
    computed: {
        pageTitle() {
            if (this.seoTags?.page_title) return this.seoTags.page_title;

            return `${this.brand.name} Tyre Reviews`;
        },
        pageMetaDesc() {
            if (this.seoTags?.meta_description) return this.seoTags.meta_description;

            return `Read reviews for popular ${this.brand.name} tyres, here at ${this.config.name}. Check factors such as the value for money, wet-grip & comfort as graded by owners.`;
        }
    },
    mounted() {
        this.getTopReviews();
        this.getTopProducts();
        this.getLatestReviews();
        this.getAllProducts();

        var lazyLoadInstance = new LazyLoad({});
    },
    methods: {
        async getTopReviews() {
            this.loadTopReviews = true;

            const response = await axios.get(this.route("brand.reviews.top", this.brand));

            const topReviews = [...this.topReviews];
            topReviews.push(...response.data);

            this.topReviews = topReviews;

            this.loadTopReviews = false;
        },
        async getTopProducts() {
            this.loadPopularProducts = true;

            const response = await axios.get(this.route("brand.products.top_products", this.brand), {
                params: {
                    season: this.season
                }
            });

            this.popularProducts = response.data;

            this.loadPopularProducts = false;
        },
        async getLatestReviews() {
            this.loadLatestReviews = true;

            const response = await axios.get(this.route("brand.products.latest_reviews", this.brand), {
                params:
                    {
                        page: this.currentPage
                    }
            });

            this.nextReviewPage = response.data.next_page_url;

            const latestReviews = [...this.latestReviews];
            latestReviews.push(...response.data.data);

            this.latestReviews = latestReviews;

            this.loadLatestReviews = false;
        },
        async getAllProducts() {
            this.loadAllProducts = true;

            const response = await axios.get(this.route("brand.products.all", this.brand), {
                params:
                    {
                        season: this.season,
                        page: this.currentProductPage
                    }
            });

            this.nextProductPage = response.data.next_page_url;

            const allProducts = [...this.allProducts];
            allProducts.push(...response.data.data);

            this.allProducts = allProducts;

            this.loadAllProducts = false;
        },
        tabChange(season) {
            this.season = season;

            // Clear all products
            this.allProducts = [];

            // Reset pagination
            this.currentProductPage = 1;

            this.getAllProducts();
            this.getTopProducts();
        },
        loadMoreProducts() {
            this.currentProductPage++;

            this.getAllProducts();
        },
        loadMore() {
            this.currentPage++;

            this.getLatestReviews();
        },
        scrollPageTo(id) {
            document.getElementById(id).scrollIntoView(
                {
                    behavior: "smooth"
                }
            );
        }
    }
};
</script>

<style scoped>

</style>
